import { render, staticRenderFns } from "./renewalSuccess.vue?vue&type=template&id=2ca65db5&scoped=true"
import script from "./renewalSuccess.vue?vue&type=script&lang=js"
export * from "./renewalSuccess.vue?vue&type=script&lang=js"
import style0 from "./renewalSuccess.vue?vue&type=style&index=0&id=2ca65db5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca65db5",
  null
  
)

export default component.exports